import { AuthView } from '../../hooks/useAuthForm';

interface AuthHeaderProps {
  view: AuthView;
}

export default function AuthHeader({ view }: AuthHeaderProps) {
  const getHeaderTitle = (view: AuthView) => {
    switch (view) {
      case 'sign_up':
        return 'Create an Account';
      case 'sign_in':
        return 'Sign in to Jua';
      case 'update_password':
        return 'Update Password';
      case 'forgotten_password':
        return 'Reset Password';
      default:
        return 'Welcome to Jua';
    }
  };

  const getHeaderText = (view: AuthView) => {
    switch (view) {
      case 'sign_up':
        return '';
      case 'sign_in':
        return '';
      case 'update_password':
        return 'Set your new password';
      case 'forgotten_password':
        return 'Reset your password';
      default:
        return '';
    }
  };

  return (
    <div className="px-6 pt-6 pb-4 text-center">
      <div className="flex justify-center mb-4">
        <img
          src="/assets/jua-logo.svg"
          alt="Jua"
          className="h-7 w-auto dark:invert dark:brightness-200"
        />
      </div>
      <h1 className="text-xl font-bold text-theme-light-text-primary dark:text-theme-dark-text-primary mb-1">
        {getHeaderTitle(view)}
      </h1>
      <p className="text-sm text-theme-light-text-secondary dark:text-theme-dark-text-secondary">
        {getHeaderText(view)}
      </p>
    </div>
  );
}
